export default __webpack_public_path__ + "static/media/detail-iv-audio-thumbnail@3x.dc82c918.png";